export const APP_FILTER_GAMES = "APP_FILTER_GAMES";
export const APP_SET_SELECTED_INDEX = "APP_SET_SELECTED_INDEX";
export const APP_SET_FILTER = "APP_SET_FILTER";
